module.exports = __webpack_public_path__ + "img/button-Dentist-Assoc.85dddd70.svg";